import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledError = styled.div`
  color: red;
  margin-bottom: 0;
`;

const Error = ({ text }) => <StyledError>{text}</StyledError>;

Error.propTypes = {
  text: PropTypes.string.isRequired
};

export default Error;
